import styled from 'styled-components';

const FallbackErrorComponent = ({ className }) => {
  return (
    <div className={className} data-testid="fallback_error">
      <h2>There was an unexpected error with TMS 😢</h2>
    </div>
  );
};

const StyledFallbackErrorComponent = styled(FallbackErrorComponent)`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const FallbackErrorComponentWrapper = (props) => <StyledFallbackErrorComponent {...props} />;

export default FallbackErrorComponentWrapper;
